export const posScans = {
  namespaced: true,
  state: { items: [], currentItem: null },
  mutations: {
    ADD_ITEM(state, item) {
      state.items.push(item);
    },
    SET_CURRENT_ITEM(state, item) {
      state.currentItem = item;
    },
    REMOVE_ITEM(state) {
      state.items.shift();
    },
  },
  actions: {
    addItem({ commit }, item) {
      commit("ADD_ITEM", item);
    },
    consumeItem({ commit, state }) {
      if (state.items.length > 0) {
        const item = state.items[0];
        commit("SET_CURRENT_ITEM", item);
        commit("REMOVE_ITEM");
      } else {
        commit("SET_CURRENT_ITEM", null);
      }
    },
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getCurrentItem(state) {
      return state.currentItem;
    },
  },
};
